import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { DeleteScopedSchedulesDialog } from "../../components/delete-scoped-schedules-dialog"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import { deleteScopedSchedule } from "authoring/routes/project/controller/delete-scoped-schedule"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { useParams } from "react-router"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_MANAGE_WORK_PACKAGES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"

export function DeleteSchedule() {
    const { targetId: scheduleId, schedule, target } = useBoundContext()
    const { projectId } = useParams()
    const disabled = isLockedToLegacy(target?.phase) || !!target?.archived

    const openDeleteScheduleDialog = useDialog(<DeleteScopedSchedulesDialog selectedSchedules={[schedule]} />, {
        maxWidth: "md",
        fullWidth: true,
    })
    return (
        <Secure demand={AUTHORING_MANAGE_WORK_PACKAGES_DEMAND} fallback={<Frag />}>
            <ContextMenuItem
                icon="gravity-ui:trash-bin"
                label="Remove"
                onClick={() => deleteSchedule({ projectId, scheduleId, openDeleteScheduleDialog })}
                disabled={disabled}
            />
        </Secure>
    )
}

async function deleteSchedule({ projectId, scheduleId, openDeleteScheduleDialog }) {
    try {
        const deleteScheduleDialog = await openDeleteScheduleDialog()
        if (deleteScheduleDialog) {
            const deleted = await deleteScopedSchedule({ projectId, scheduleId })
            if (deleted) {
                successSnackbar("Schedule successfully removed")
            } else {
                errorSnackbar("Failed to remove schedule")
            }
        }
    } catch (error) {
        console.error(error)
        errorSnackbar("Failed to remove schedule")
    }
}
